import { getMaintenanceAlert } from 'utils/API';

import { useQuery } from 'react-query';

export default function useMaintenanceAlertQuery(override = {}) {
  return useQuery(['maintenance-alert'], getMaintenanceAlert, {
    ...override,
    staleTime: Infinity,
    select: data => ({
      ...data.data,
    }),
  });
}
